module.exports = __webpack_public_path__ + "static/img/02450_9.47a0c20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02450_9.jpg
// module id = IUjS
// module chunks = 1